/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { FiltersProductTable } from '../../components/catalogPage/filtersProductTable';
import { Filters } from '../../components/catalogPage/filtersMenu';
import { useDispatch } from 'react-redux';
import { getSuppliersAction, searchSuppliersAction } from '../../../modules/cart/actions';
import { useAppSelector } from '../../../utils/reduxHooks';
import { selectParts, selectSelectedSubGroupItem } from '../../../modules/catalog/selectors';
import { DEFAULT_PRICE_RANGE, DEFAULT_DELIVERY_DAYS } from '../../../constants/filters';
import { getPartsAction, searchByVINAction } from '../../../modules/catalog/actions';
import { useParams } from 'react-router-dom';

export const FiltersPage = () => {
  const dispatch = useDispatch();
  const parts = useAppSelector(selectParts);
  const { type, mark, model, modification, group, parentId, searchText } = useParams();

  const selectedSubGroupItem = useAppSelector(selectSelectedSubGroupItem);

  const [filters, setFilters] = useState({
    priceRange: DEFAULT_PRICE_RANGE,
    deliveryDays: DEFAULT_DELIVERY_DAYS,
    inStockOnly: false,
    originalOnly: false,
    manufacturers: [],
    suppliers: [],
  });

  const handleFilterChange = (updatedFilters: any) => {
    setFilters(prevFilters => ({ ...prevFilters, ...updatedFilters }));
  };

  const createSearchParams = useCallback(() => {
    const params: any = {};

    // Добавляем только те параметры, которые изменены
    if (filters.priceRange[0] !== DEFAULT_PRICE_RANGE[0]) {
      params.price_gt = filters.priceRange[0];
      params.price_lt = filters.priceRange[1];
    }
    if (filters.priceRange[1] !== DEFAULT_PRICE_RANGE[1]) {
      params.price_gt = filters.priceRange[0];
      params.price_lt = filters.priceRange[1];
    }

    if (filters.deliveryDays[0] !== DEFAULT_DELIVERY_DAYS[0]) {
      params.delivery_term_gt = filters.deliveryDays[0] === 0 ? '0' : filters.deliveryDays[0];
      params.delivery_term_lt = filters.deliveryDays[1];
    }
    if (filters.deliveryDays[1] !== DEFAULT_DELIVERY_DAYS[1]) {
      params.delivery_term_gt = filters.deliveryDays[0] === 0 ? '0' : filters.deliveryDays[0];
      params.delivery_term_lt = filters.deliveryDays[1];
    }

    if (filters.inStockOnly) {
      params.amount_gt = +filters.inStockOnly;
    }
    if (filters.originalOnly) {
      params.brand = +filters.originalOnly;
    }

    if (filters.suppliers.length > 0) {
      params.supplier = filters.suppliers[0];
    }

    if (searchText) {
      params.search_text = searchText;
    }

    return params;
  }, [filters, searchText]);

  const fetchSuppliers = useCallback(
    (searchParams: any) => {
      // console.log(searchText, 'searchText');

      // const params = {
      //   ...searchParams,
      //   price_gt: filters.priceRange[0],
      //   price_lt: filters.priceRange[1],
      //   delivery_term_gt: filters.deliveryDays[0] === 0 ? '-1' : filters.deliveryDays[0],
      //   delivery_term_lt: filters.deliveryDays[1],
      //   supplier: filters.suppliers[0],
      //   text: searchText || '',
      // };

      dispatch(searchSuppliersAction.request(searchParams));
    },
    [dispatch, filters, searchText],
  );

  // const debouncedFetchSuppliers = useMemo(
  //   () =>
  //     debounce((searchParams: any) => {
  //       fetchSuppliers(searchParams);
  //     }, DEBOUNCE_DELAY_MS),
  //   [fetchSuppliers],
  // );

  // // Загрузка списка поставщиков при инициализации
  // useEffect(() => {
  //   dispatch(getSuppliersAction.request(searchText || ''));
  // }, [dispatch, searchText]);

  // Загрузка запчастей при изменении параметров
  useEffect(() => {
    if (!parts) {
      dispatch(getPartsAction.request({ type, mark, model, modification, group, parentId }));
    }
  }, [parts, type, mark, model, modification, group, parentId, dispatch]);

  // Первоначальная загрузка данных
  // useEffect(() => {
  //   const initialSearchParams = createSearchParams();
  //   if (initialSearchParams) {
  //     fetchSuppliers(initialSearchParams);
  //   }
  // }, [dispatch, parts, selectedSubGroupItem, fetchSuppliers, createSearchParams]);

  // Динамическая загрузка при изменении фильтров
  useEffect(() => {
    const searchParams = createSearchParams();
    // console.log(searchParams, 'searchParamssearchParams');

    if (searchParams || searchText) {
      // debouncedFetchSuppliers(searchParams);
      fetchSuppliers(searchParams);
    }

    // Очистка debounce при размонтировании компонента
    // return () => debouncedFetchSuppliers.cancel();
  }, [filters, parts, selectedSubGroupItem, searchText]);

  return (
    <Flex>
      <Filters onFilterChange={handleFilterChange} />
      <Box flex="1">
        <FiltersProductTable />
      </Box>
    </Flex>
  );
};
